export default "<div class=\"content\">\n  <router-outlet></router-outlet>\n</div>";